<template>
  <v-switch
          v-model="selectValue"
          :label="name"
          :rules="rules"
          :disabled="disabled"
          :hide-details="hideDetails"
  >
  </v-switch>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "SwitchField",
    props: {
      "value": Boolean,
      "name": String,
      "required": Boolean,
      "disabled": Boolean,
      "hideDetails": Boolean,
      "submit": Function,
    },
    computed: {
      selectValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("change", value)
          this.$emit("input", value)
        }
      },
      rules () {
        return [
          value => {
            if (this.required) {
              return !!value || this.error("required", [this.name]);
            }
            return true;
          }
        ]
      }
    },
    methods: {
      onSubmit () {
        if (this.submit) {
          this.submit()
        }
      }
    },
  }
</script>

<style scoped>

</style>